import { useLanguage } from "@/context/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const content = t.marquee.repeat(3);
  return (
    <div data-testid="editorial-marquee" className="border-y border-gold/20 bg-coal py-5 overflow-hidden select-none">
      <div className="flex whitespace-nowrap animate-gc-marquee w-max">
        <span className="font-serif italic text-xl sm:text-2xl text-champagne/70 tracking-[0.2em] pr-4">{content}</span>
        <span className="font-serif italic text-xl sm:text-2xl text-champagne/70 tracking-[0.2em] pr-4" aria-hidden="true">{content}</span>
      </div>
    </div>
  );
};
